import type { ModuleNode } from "../types";

import { dataEstateModule } from "./dataestate";
import { dataPipelineModule } from "./datapipeline";
import { xOpsModule } from "./Xops"
import { programExecutiveModule } from "./programExecutive";
import { finopsModule } from "./finops";
import { finopsExecutiveModule } from "./finopsExecutive";
import { platformObservabilityModule } from "./platformObservability";
import { MLObservabilityModule } from "./MLObservability";
import { AlertModule } from "./AlertFramework";
import { hideML } from '../../../service/config'

export const allModules: ModuleNode[] = [
  dataEstateModule,
  dataPipelineModule,
  xOpsModule,
  programExecutiveModule,
  finopsModule,
  finopsExecutiveModule,
  platformObservabilityModule,
  ...(hideML ? [] : [MLObservabilityModule]),
  AlertModule
];
